<template>
  <div>
    <vggrid  :random="Math.floor(Math.random() * 999999)" :list="psuList" tableheight="400" flexname="" :cols="cols"
            :showfooter="false" :showPage="false" :resizable="true"
            @cellClick="cellClick" @cellDblClick="viewProject"
    >
      <template slot="btn">
        <div class="export-btn-container">
          <el-button type="primary" size="small" @click="exportPDF" :loading="btnLoading" icon="el-icon-download">导出初审汇总PDF</el-button>
        </div>
      </template>
    </vggrid>
    <div class="split-line"></div>
    <div v-if="pexpert">
      <!--<div>-->
        <!--<div>评审人[{{pexpert.pexpertname}}]的初审过程</div>-->
      <!--</div>-->
      <pqces-form-check-com-by-ex :projectid="projectid" :pexpert="pexpert" :pexpertid="pexpert.pexpertid"></pqces-form-check-com-by-ex>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import PqcesFormCheckComByEx from './pqcesFormCheckComByEx'
  import utils from '../../assets/js/utils'

  export default {
    name: 'pqcFormCheckSumIndex',
    components: {vggrid, PqcesFormCheckComByEx},
    props: {
      projectid: {},
      activeName: {}
    },
    data () {
      return {
        pexpert: '',
        project: {},
        psuList: [],
        pqcesList: [],
        pexpertInfo: {},
        pexertList: [],
        btnLoading: false,
        model: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        cols: [
          { field: 'comfullname', fieldtype: 'I', title: '供应商', calculExpr: '' }
        ]
      }
    },
    created () {
      // this.getModel()
    },
    activated () {
      this.pexpert = ''
    },
    mounted () {
      this.pexpert = ''
      this.getAllpfList()
      this.getModel()
    },
    watch: {
      activeName () {
        if(this.activeName === 'sc') {
          this.cols = [
            {field: 'comfullname', fieldtype: 'I', title: '供应商', calculExpr: ''}
          ]
          this.pexpert = ''
          this.getAllpfList()
        }
      }
    },
    methods: {
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.projectid}
        })
        this.project = res
      },
      async getAllpfList () {
        let data = await request({
          method: 'get',
          url: 'expert/getAllpfList',
          params: {projectid: this.projectid}
        })
        this.psuList = data.psuList
        this.pqcesList = data.pqcesList
        this.pexertList = data.pexertList
        this.setCrossCols(data)
        this.totalScore(this.pqcesList)
      },
      async setCrossCols (res) {
        if (res.pexertList.length > 0) {
          for (let i = 0; i < res.pexertList.length; i++) {
            let item = res.pexertList[i]
            this.cols.push({
              // title: (item.pexpertname == null ? item.pexpertlogincode : item.pexpertname)+'',
              width: 135,
              slots: {
                default: 'default',
                default: ({row}) => {
                  return this.getCrossCheckResultDesc({pexpertid: item.pexpertid, psucomid: row.psucomid})
                },
                header: ({ column }) => {
                  return [
                    (item.pexpertname == null ? item.pexpertlogincode : item.pexpertname),
                    <span onClick={this.viewGc.bind(this,column,item)} style="color: #409EFF;padding-left:5px">查看过程</span>
                  ]
                }
              }
            })
          }
        }
        // this.cols.push({field: 'psupqcesresult',syscode:'psupqcesresult',fieldtype: 'C', title: '汇总结果', calculExpr: '',editRender: { name: 'select', options: []}})
        this.cols.push({
          title: '汇总结果',
          width: 80,
          slots: {
            default: 'default',
            default: ({row}) => {
              if (+row.psupqcesresult === 1) {
                return '通过'
              }
              if (+row.psupqcesresult === 2) {
                return '不通过'
              }
              else {
                return '无'
              }
            }
          }
        })
        this.cols.push({
          title: '意见',
          slots: {
            default: 'default',
            default: ({row}) => {
              return row.psupqcescdesc
            }
          }
        })
      },
      viewGc (col,item) {
        console.log(col, item)
        this.pexpert = item
      },
      getCrossCheckResultDesc (item) {
        let code = this.pqcesList.filter(v => +v.pqcesexpertid === +item.pexpertid && +v.pqcescomid === +item.psucomid)
        let i = code.length > 0 ? code[0].pqcesresultdesc : ''
        return i
      },
      totalScore (e) {
        console.log(this.psuList.length)
        let ty = 0, bty = 0
        for(let i = 0;i < this.psuList.length; i++){
          let sum = 0
          for(let j = 0;j <this.pqcesList.length; j++){
              if(this.psuList[i].psucomid === this.pqcesList[j].pqcescomid){
                if(+this.pqcesList[j].pqcesresult === 1){
                    ty++
                }
                if(+this.pqcesList[j].pqcesresult === 2){
                    bty++
                }
              }
          }
          // if(ty > bty){
          //   this.psuList[i].psupqcesresult = '1'
          // }
          if(bty === 0 && ty === 0){
            this.psuList[i].psupqcesresult = '3'
          }
          else if(bty > 0){
            this.psuList[i].psupqcesresult = '2'
          }
          else
            this.psuList[i].psupqcesresult = '1'
          ty = 0,bty = 0
        }
      },
      async getpsrecList () {
        let prsList = await request({
          method: 'get',
          url: 'expert/getpsrecList',
          params: {psprojectid: this.projectid}
        })

        if (prsList.length > 0) {
          this.psuList.forEach(e => {
            e.psdesc = prsList.filter(v => +v.pscomid === +e.psucomid && +v.psprojectid === +e.psuprojectid)[0].psdesc
          })
        }
      },
      async cellClick (row) {
        this.model = row
      },
      async viewProject (row) {
        this.model = row
      },
      getOpinion (item) {
        if (item.psupqcescdesc && item.psupqcescdesc.trim()) {
          return item.psupqcescdesc.trim()
        }
        if (+item.psupqcesresult === 2) {
          return '报价无效'
        }
        if (this.psuList.length === 1) {
          return '推荐为成交候选供应商'
        }
        return '进入下一步详细评分'
      },
      getExpertResult (psucomid, pexpertid) {
        let code = this.pqcesList.filter(v => +v.pqcesexpertid === +pexpertid && +v.pqcescomid === +psucomid)
        return code.length > 0 ? code[0].pqcesresultdesc : ''
      },
      exportPDF() {
        this.btnLoading = true
        if (typeof html2canvas === 'undefined' || typeof jsPDF === 'undefined') {
          const script1 = document.createElement('script')
          script1.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js'
          script1.onload = () => {
            const script2 = document.createElement('script')
            script2.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js'
            script2.onload = () => {
              this.generatePDF()
            }
            document.head.appendChild(script2)
          }
          document.head.appendChild(script1)
        } else {
          this.generatePDF()
        }
      },
      generatePDF() {
        const exportContainer = document.createElement('div')
        exportContainer.style.width = '100%'
        exportContainer.style.padding = '20px'
        exportContainer.style.backgroundColor = '#fff'

        const title = document.createElement('h2')
        title.style.textAlign = 'center'
        title.style.marginBottom = '15px'
        title.textContent = '项目初审汇总表'
        exportContainer.appendChild(title)

        const projectInfo = document.createElement('div')
        projectInfo.style.display = 'flex'
        projectInfo.style.justifyContent = 'space-between'
        projectInfo.style.marginBottom = '20px'

        const projectName = document.createElement('span')
        projectName.textContent = `项目名称：${this.project.projectname || ''}`
        projectInfo.appendChild(projectName)

        const projectCode = document.createElement('span')
        projectCode.textContent = `项目编号：${this.project.projectcode || ''}`
        projectInfo.appendChild(projectCode)

        exportContainer.appendChild(projectInfo)

        const table = document.createElement('table')
        table.style.width = '100%'
        table.style.borderCollapse = 'collapse'

        const thead = document.createElement('thead')
        const headerRow = document.createElement('tr')

        const serialHeader = document.createElement('th')
        serialHeader.style.border = '1px solid #000'
        serialHeader.style.padding = '8px'
        serialHeader.style.textAlign = 'center'
        serialHeader.textContent = '序号'
        headerRow.appendChild(serialHeader)

        const supplierHeader = document.createElement('th')
        supplierHeader.style.border = '1px solid #000'
        supplierHeader.style.padding = '8px'
        supplierHeader.style.textAlign = 'center'
        supplierHeader.textContent = '供应商名称'
        headerRow.appendChild(supplierHeader)

        this.pexertList.forEach((expert, index) => {
          const expertHeader = document.createElement('th')
          expertHeader.style.border = '1px solid #000'
          expertHeader.style.padding = '8px'
          expertHeader.style.textAlign = 'center'
          expertHeader.textContent = expert.pexpertname || expert.pexpertlogincode || `评委${index + 1}`
          headerRow.appendChild(expertHeader)
        })

        const resultHeader = document.createElement('th')
        resultHeader.style.border = '1px solid #000'
        resultHeader.style.padding = '8px'
        resultHeader.style.textAlign = 'center'
        resultHeader.textContent = '汇总结果'
        headerRow.appendChild(resultHeader)

        const opinionHeader = document.createElement('th')
        opinionHeader.style.border = '1px solid #000'
        opinionHeader.style.padding = '8px'
        opinionHeader.style.textAlign = 'center'
        opinionHeader.textContent = '意见'
        headerRow.appendChild(opinionHeader)

        thead.appendChild(headerRow)
        table.appendChild(thead)

        const tbody = document.createElement('tbody')
        this.psuList.forEach((row, index) => {
          const dataRow = document.createElement('tr')

          const serialCell = document.createElement('td')
          serialCell.style.border = '1px solid #000'
          serialCell.style.padding = '8px'
          serialCell.style.textAlign = 'center'
          serialCell.textContent = index + 1
          dataRow.appendChild(serialCell)

          const supplierCell = document.createElement('td')
          supplierCell.style.border = '1px solid #000'
          supplierCell.style.padding = '8px'
          supplierCell.textContent = row.comfullname
          dataRow.appendChild(supplierCell)

          this.pexertList.forEach(expert => {
            const expertCell = document.createElement('td')
            expertCell.style.border = '1px solid #000'
            expertCell.style.padding = '8px'
            expertCell.style.textAlign = 'center'
            expertCell.textContent = this.getExpertResult(row.psucomid, expert.pexpertid)
            dataRow.appendChild(expertCell)
          })

          const resultCell = document.createElement('td')
          resultCell.style.border = '1px solid #000'
          resultCell.style.padding = '8px'
          resultCell.style.textAlign = 'center'
          let resultText = '无'
          if (+row.psupqcesresult === 1) {
            resultText = '通过'
          } else if (+row.psupqcesresult === 2) {
            resultText = '不通过'
          }
          resultCell.textContent = resultText
          dataRow.appendChild(resultCell)

          const opinionCell = document.createElement('td')
          opinionCell.style.border = '1px solid #000'
          opinionCell.style.padding = '8px'
          opinionCell.style.textAlign = 'center'
          opinionCell.textContent = this.getOpinion(row)
          dataRow.appendChild(opinionCell)

          tbody.appendChild(dataRow)
        })

        table.appendChild(tbody)
        exportContainer.appendChild(table)
        document.body.appendChild(exportContainer)

        const { jsPDF } = window.jspdf
        const pdf = new jsPDF('l', 'mm', 'a4')

        html2canvas(exportContainer, {
          scale: 2,
          useCORS: true,
          allowTaint: true
        }).then(canvas => {
          const imgData = canvas.toDataURL('image/png')
          const imgWidth = 297
          const imgHeight = canvas.height * imgWidth / canvas.width

          pdf.addImage(imgData, 'PNG', 10, 10, imgWidth - 20, imgHeight)
          pdf.save(`初审汇总_${this.project.projectname || '项目'}.pdf`)

          document.body.removeChild(exportContainer)
          this.btnLoading = false
        }).catch(err => {
          console.error('生成PDF失败', err)
          if (exportContainer.parentNode) {
            document.body.removeChild(exportContainer)
          }
          this.btnLoading = false
          this.$message.error('生成PDF失败')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .export-btn-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }
</style>
